var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpoonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33826 6.5237C0.673704 4.94388 0.673704 2.45262 2.33826 0.872803L9.44465 7.61743L11.8134 9.86564L15.4627 13.3291C16.1029 13.9367 16.1029 14.8482 15.4627 15.4558C14.8225 16.0634 13.6701 16.0634 13.0939 15.3342L10.469 12.2354C9.82878 11.4455 8.67639 11.2024 7.65205 11.567L2.33826 6.5237Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 5.67301L15.2697 2.39185",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4062 8.52889C10.6623 8.46812 10.8544 8.46813 11.1105 8.40736C11.9428 8.3466 12.9031 7.92126 13.8634 7.00983L17.0005 4.03247",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05226 10.0481L1.57076 13.5116C0.866524 13.9977 0.802502 14.9698 1.44272 15.5167C2.08293 16.1243 3.04325 16.0028 3.55543 15.3952L7.20465 11.0811",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5438 0.751465L10.3427 3.72882C9.3824 4.64026 8.87023 5.55169 8.87023 6.3416C8.87023 6.58465 8.80621 6.76694 8.74219 7.00999",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpoonIcon);
export default __webpack_public_path__ + "static/media/spoonIcon.fd3280ea3cffd3d9f490e0a6f83b3fca.svg";
export { ForwardRef as ReactComponent };